export default __webpack_public_path__ + "img/logo2.png";